<div *ngIf="errors" class="alert alert-danger alert-dismissible fade show">
  Invalid form: make sure to select the checkboxes a. b. and c. and fill the confirmed by section.
  <button (click)="errors = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="serverError" class="alert alert-danger alert-dismissible fade show">
  An error has occurred while submitting your declaration.
  <button (click)="serverError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="expiredError" class="alert alert-danger alert-dismissible fade show">
  This dad form is no longer editable.
  <button (click)="expiredError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="successDeclaration" class="alert alert-success alert-dismissible fade show">
  The declaration has been successfully submitted.
  <button (click)="successDeclaration = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="!loading" class="container">
  <div>
    <h4 style="margin-bottom: 0; line-height: 100%; text-align: center ">
      <b>
        <u>Monthly Data Access Declaration (TQ)</u>
      </b>
    </h4>
    <br>
    <p>
      <b>Vendor Providing the Datafeed:</b> {{ currentDad.vendor }}
    </p>
    <div>
      <b>Subscriber Name: </b>
      <span>{{ currentDad.billingAccount.name }}</span>
    </div>
    <br>
    <div>
      <b>Location Address covered on this report: </b>
    </div>
    <table>
      <tr *ngFor="let pop of currentDad.decodedPopList">
        <td style="text-align:center; font-weight:bold;"> &#8226;</td>
        <td style="padding: 3px">{{ pop.name }}</td>
        <td style="padding: 3px">{{ pop.street }}</td>
        <td style="padding: 3px">{{ pop.city }}</td>
        <td style="padding: 3px">{{ pop.state }}</td>
        <td style="padding: 3px">{{ pop.postal_code }}</td>
      </tr>
    </table>
    <br>
    <div>
      <b>This Declaration Form covers data in relation to the following Exchanges for the month(s) listed</b>
    </div>
    <br/>

    <div [formGroup]="dadDeclarationForm">
      <table class="declaration-table" style="width: 60%">
        <thead>
        <tr>
          <th>
            Quincy Data exchange name
          </th>
          <th *ngFor="let market of currentDad.markets">
            {{ market }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let pop of currentDad.decodedPopList">
          <td>
            {{ pop.name }} {{ pop.street }}
          </td>
          <ng-container *ngFor="let market of currentDad.markets">
            <td style="text-align: center;">
              {{ this.colsXArray[market + pop.name] }}
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="previousMonthSubscriptionData?.declarations && seePreviousMonthDeclaration"
            class="tr-previous-month-declaration">
          <th>
            {{ previousUsageMonth | date: 'MMMM yyyy':'+8000' }}
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td style="border: 1px solid #ddd; padding: 8px;">
              <input [disabled]="true" [value]="previousMonthDeclarationValue(market)" style="width: 100%" type="text">
            </td>
          </ng-container>
        </tr>

        <tr *ngIf="seeOriginalClientDeclaration" class="tr-previous-month-declaration">
          <th>
            {{ currentDad.usageMonth | date: 'MMMM yyyy':'+8000' }}
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td style="border: 1px solid #ddd; padding: 8px;">
              <input [disabled]="true" [value]="clientOriginalMonthDeclarationValue(market)" style="width: 100%" type="text">
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!originalClientDeclarationMode">
          <th style="border: 1px solid #ddd; padding: 12px 8px;text-align: center;">
            {{ currentDad.usageMonth | date: 'MMMM yyyy':'+8000' }}
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td style="border: 1px solid #ddd; padding: 8px;">
              <input [formControlName]="market" min="0" type="number">
            </td>
          </ng-container>
        </tr>
        </tbody>
      </table>
      <div class="row" style="margin-left: 0; margin-top: 5px;" *ngIf="!originalClientDeclarationMode">
        <button (click)="toggleSeePreviousMonthDeclaration()" *ngIf="previousMonthSubscriptionData?.declarations" class="p-button-alert"
                label="{{previousMonthDeclarationBtnLabel}}" pButton></button>
        <button (click)="toggleSeeOriginalClientDeclaration()" *ngIf="currentDad.decodedOriginalClientDeclaration" class="p-button-info" style="margin-left: 5px;"
                label="{{originalClientDeclarationBtnLabel}}" pButton></button>
      </div>
    </div>
    <br/>
    <div>
      Unit of count: Unique User ID / Device ID per Data Source
    </div>
    <br>
    <app-confirmation-section [currentDad]="currentDad" [formGroup]="dadDeclarationForm" [originalClientDeclarationMode]="originalClientDeclarationMode"
                              [previousMonthSubscriptionData]="previousMonthSubscriptionData">
    </app-confirmation-section>

    <div class="row removable" *ngIf="!originalClientDeclarationMode">
      <div class="col-6"></div>
      <div class="col-6">
        <button (click)="onSubmit()" class="p-button-success pull-right" icon="fa fa-floppy-o"
                label="Confirm and transmit your declaration"
                pButton type="submit"></button>
        <button class="p-button-danger pull-right" label="Cancel" pButton routerLink="/dad-admin"
                style="margin-right: 5px"></button>
      </div>
    </div>
  </div>
</div>
